/**
 * Runs a field→rules map. First failing rule per field wins.
 */
export function validateWithRules(entity, rules, ctx) {
    const errors = {};
    const record = entity;
    for (const field of Object.keys(rules)) {
        const fieldRules = rules[field];
        for (const rule of fieldRules ?? []) {
            const msg = rule(record[field], entity, ctx);
            if (msg) {
                errors[field] = msg;
                break;
            }
        }
    }
    return errors;
}
//# sourceMappingURL=validateWithRules.js.map